<template>
  <ValidationObserver
    ref="observer"
    class="preservice-record-form transition duration-500 ease-in-out transform w-full"
    style="transition: all 1s !important"
    tag="form"
    @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <ValidationObserver
          ref="mainForm"
          class="flex flex-wrap my-6 mx-6 mb-6"
        >
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >First Name</label
            >
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                id="firstName"
                v-model="formValues.firstName"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name
                type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Father Name</label
            >
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                id="fatherName"
                v-model="formValues.fatherName"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name
                type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Grand Father Name</label
            >
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                id="grandFatherName"
                v-model="formValues.grandFatherName"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name
                type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Sex</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                id="Male"
                v-model="formValues.sex"
                class="my-3 ml-5"
                type="radio"
                value="Male"
              />
              <label for="Male"> Male </label>

              <input
                id="Female"
                v-model="formValues.sex"
                class="my-3 ml-5"
                type="radio"
                value="Female"
              />
              <label for="Female"> Female </label>
              <br />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br />
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >National ID (FAN)</label
            >
            <validation-provider v-slot="{ errors }" rules="required|fan_id">
              <input
                id="idNo"
                v-model="formValues.idNo"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                inputmode="numeric"
                maxlength="19"
                name
                placeholder="1234 2345 7865 5466"
                type="text"
                @blur="loadExistingStudentIdentity"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full">
            <div
              class="title"
              style="background-color: #f3f3f3; padding: 5px 24px"
            >
              About Higher Learning Institution
            </div>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >University / Educational Institution</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="selectedUniversity"
                :disabled="isUniversityScopedUser"
                :elevation="1"
                :items="UNIVERSITIES"
                :loading="universityLoading"
                dense
                item-text="name"
                return-object
                solo
                @change="onUniversityChanged"
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >University Owner</label
            >
            <v-text-field
              :value="selectedUniversity?.ownership?.name || ''"
              dense
              readonly
              solo
            ></v-text-field>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Region</label
            >
            <v-text-field
              :value="selectedUniversity?.region?.name || ''"
              dense
              readonly
              solo
            ></v-text-field>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Town</label
            >
            <v-text-field
              :value="selectedUniversity?.town || ''"
              dense
              readonly
              solo
            ></v-text-field>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Background Profession</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formValues.backgroundProfession"
                :disabled="
                  isGraduateEntryProgram && BACKGROUND_PROFESSIONS.length === 1
                "
                :elevation="1"
                :items="BACKGROUND_PROFESSIONS"
                :loading="lookupLoading"
                dense
                item-text="name"
                item-value="name"
                solo
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >{{ programEducationTypeLabel }}</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                v-model="formValues.educationProgramId"
                :elevation="1"
                :items="EDUCATIONAL_PROGRAMS"
                :loading="lookupLoading"
                dense
                item-text="name"
                item-value="id"
                solo
              ></v-select>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Department / Discipline</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="disciplineValue"
                :elevation="1"
                :items="DISCIPLINES"
                :loading="lookupLoading"
                dense
                item-text="name"
                return-object
                solo
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Level Of Study</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                v-model="formValues.levelOfStudyId"
                :elevation="1"
                :items="LEVEL_OF_STUDIES"
                :loading="lookupLoading"
                dense
                item-text="name"
                item-value="id"
                solo
              ></v-select>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Year of Entry</label
            >
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required: true,
                post_graduate_regex: '^[0-9]{4}$',
                min_graduate_value: 1950,
                max_entry_value: currentYear,
              }"
            >
              <YearPickerField
                v-model="formValues.entryYear"
                :max-year="currentYear"
                :min-year="1950"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Expected Graduation Year</label
            >
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required: true,
                post_graduate_regex: '^[0-9]{4}$',
                min_expected_value: +formValues.entryYear + 2,
              }"
            >
              <YearPickerField
                v-model="formValues.expectedYear"
                :disabled="!formValues.entryYear"
                :min-year="+formValues.entryYear + 2"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Year Of Graduation</label
            >
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                generic_regex: '^[0-9]{4}$',
                min_proposed_value: +formValues.expectedYear,
              }"
            >
              <YearPickerField
                v-model="formValues.graduationYear"
                :disabled="!formValues.expectedYear"
                :min-year="+formValues.expectedYear"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div v-if="supportsStudentGradeTracking" class="w-full">
            <div
              class="preservice-status-section-title title"
            >
              Student Grade Information
            </div>
          </div>
          <ValidationObserver
            v-if="supportsStudentGradeTracking"
            ref="subForm"
            class="w-full"
          >
            <v-card
              class="preservice-status-entry-card flex flex-wrap my-2 mb-4"
              outlined
            >
              <div class="w-full">
                <v-container class="preservice-status-entry-container">
                  <v-row class="preservice-status-entry-row" dense>
                    <v-col class="preservice-status-field" cols="12" md="3" sm="6">
                      <label
                        class="preservice-status-label"
                        >Year Of Education</label
                      >
                      <validation-provider
                        v-slot="{ errors }"
                        :disabled="skipStudentStatusDraftValidation"
                        rules="required"
                      >
                        <v-autocomplete
                          v-model="studentStatusItem.yearOfEducation"
                          :elevation="1"
                          :items="YEAR_OF_EDUCATION"
                          :loading="lookupLoading"
                          class="preservice-status-control"
                          dense
                          hide-details
                          item-text="name"
                          item-value="name"
                          outlined
                        ></v-autocomplete>
                        <span
                          class="preservice-status-error text-gray-600 text-xs italic text-red-700"
                          >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-field" cols="12" md="3" sm="6">
                      <label
                        class="preservice-status-label"
                        >Student Status</label
                      >
                      <validation-provider
                        v-slot="{ errors }"
                        :disabled="skipStudentStatusDraftValidation"
                        rules="required"
                      >
                        <v-autocomplete
                          v-model="studentStatusItem.studentStatus"
                          :elevation="1"
                          :items="STUDENT_STATUSES"
                          :loading="lookupLoading"
                          class="preservice-status-control"
                          dense
                          hide-details
                          item-text="name"
                          item-value="name"
                          outlined
                        ></v-autocomplete>
                        <span
                          class="preservice-status-error text-gray-600 text-xs italic text-red-700"
                          >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-field" cols="12" md="2" sm="6">
                      <label
                        class="preservice-status-label"
                        >GPA:
                      </label>
                      <validation-provider
                        v-slot="{ errors }"
                        :disabled="skipStudentStatusDraftValidation"
                        :rules="{ required: true, min_gpa: 0, max_gpa: 4 }"
                      >
                        <v-text-field
                          v-model="studentStatusItem.gpa"
                          class="preservice-status-control"
                          dense
                          hide-details
                          outlined
                          step="0.01"
                          type="number"
                        ></v-text-field>
                        <span
                          class="preservice-status-error text-gray-600 text-xs italic text-red-700"
                          >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-field" cols="12" md="2" sm="6">
                      <label
                        class="preservice-status-label"
                        >Cumulative GPA:
                      </label>
                      <validation-provider
                        v-slot="{ errors }"
                        :disabled="skipStudentStatusDraftValidation"
                        :rules="{ required: true, min_gpa: 0, max_gpa: 4 }"
                      >
                        <v-text-field
                          v-model="studentStatusItem.cumulativeGpa"
                          class="preservice-status-control"
                          dense
                          hide-details
                          outlined
                          step="0.01"
                          type="number"
                        ></v-text-field>
                        <span
                          class="preservice-status-error text-gray-600 text-xs italic text-red-700"
                          >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-add-cell" cols="12" md="2" sm="12">
                      <v-btn
                        class="preservice-status-add"
                        color="primary"
                        depressed
                        small
                        @click="addStudentStatus()"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div>

              <div class="w-full mb-6 md:mb-0">
                <v-data-table
                  :headers="statusHeaders"
                  :items="studentStatusItems"
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-dialog v-model="editDialog" max-width="560px">
                      <v-card class="preservice-dialog-card">
                        <v-card-title class="preservice-dialog-header preservice-dialog-header--compact">
                          <div class="preservice-dialog-header__icon">
                            <v-icon color="white">mdi-chart-timeline-variant</v-icon>
                          </div>
                          <div class="preservice-dialog-header__content">
                            <div class="preservice-dialog-header__title">Edit Student Status</div>
                            <div class="preservice-dialog-header__subtitle">
                              Update the student's year, status, and GPA.
                            </div>
                          </div>
                          <v-spacer></v-spacer>
                          <v-btn
                            aria-label="Close student status dialog"
                            class="preservice-dialog-close"
                            icon
                            @click="cancelStudentStatusEdit"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>

                        <v-card-text class="preservice-dialog-body">
                          <v-container>
                            <v-row>
                              <v-col cols="12" md="6" sm="6">
                                <v-select
                                  v-model="studentStatusItem.yearOfEducation"
                                  :elevation="1"
                                  :items="YEAR_OF_EDUCATION"
                                  :loading="lookupLoading"
                                  class="pt-5"
                                  dense
                                  item-text="name"
                                  item-value="name"
                                  solo
                                ></v-select>
                              </v-col>
                              <v-col cols="12" md="6" sm="6">
                                <v-select
                                  v-model="studentStatusItem.studentStatus"
                                  :elevation="1"
                                  :items="STUDENT_STATUSES"
                                  :loading="lookupLoading"
                                  class="pt-5"
                                  dense
                                  item-text="name"
                                  item-value="name"
                                  solo
                                ></v-select>
                              </v-col>
                              <v-col cols="12" md="6" sm="6">
                                <v-text-field
                                  v-model="studentStatusItem.gpa"
                                  class="pt-5"
                                  dense
                                  solo
                                  step="0.01"
                                  type="number"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6" sm="6">
                                <v-text-field
                                  v-model="studentStatusItem.cumulativeGpa"
                                  class="pt-5"
                                  dense
                                  solo
                                  step="0.01"
                                  type="number"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions class="preservice-dialog-actions">
                          <v-spacer></v-spacer>
                          <v-btn
                            class="preservice-dialog-cancel"
                            text
                            @click="cancelStudentStatusEdit"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            class="preservice-dialog-submit"
                            depressed
                            @click="saveStudentStatusEdit"
                          >
                            <v-icon left>mdi-content-save-outline</v-icon>
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="deleteDialog" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5">
                          Are you sure you want to delete this item?
                        </v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closeStudentStatusDelete"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="confirmRemoveStudentStatus"
                          >
                            OK
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      class="mr-2"
                      color="teal"
                      @click="editStudentStatus(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon color="red" @click="removeStudentStatus(item)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </div>
            </v-card>
          </ValidationObserver>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Nationality</label
            >
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                id="nationality"
                v-model="formValues.nationality"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name
                type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Ethnicity</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formValues.ethnicity"
                :elevation="1"
                :items="ETHNICITIES"
                :loading="lookupLoading"
                dense
                item-text="name"
                item-value="name"
                solo
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full">
            <div
              class="title"
              style="background-color: #f7fafc; padding: 5px 24px"
            >
              Birth Place
            </div>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Birth Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formValues.birthRegionId"
                :elevation="1"
                :items="BIRTH_REGIONS"
                :loading="birthPlaceLookupLoading"
                dense
                item-text="name"
                item-value="id"
                solo
                @change="onBirthRegionChange"
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Birth Zone</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formValues.birthZoneId"
                :disabled="!formValues.birthRegionId"
                :elevation="1"
                :items="BIRTH_ZONES"
                :loading="birthPlaceLookupLoading"
                dense
                item-text="name"
                item-value="id"
                solo
                @change="onBirthZoneChange"
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Birth Woreda</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formValues.birthWoredaId"
                :disabled="!formValues.birthZoneId"
                :elevation="1"
                :items="BIRTH_WOREDAS"
                :loading="birthPlaceLookupLoading"
                dense
                item-text="name"
                item-value="id"
                solo
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Town / Village</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                v-model="formValues.birthTownVillage"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="preservice-form-actions">
              <v-btn
                class="preservice-form-submit"
                depressed
                type="button"
                :disabled="submitting"
                @click="submit()"
              >
                <v-icon v-if="!submitting" left>
                  {{ formValues.editMode ? "mdi-account-check-outline" : "mdi-content-save-outline" }}
                </v-icon>
                {{
                  submitting
                    ? "Saving..."
                    : formValues.editMode
                      ? "Update"
                      : "Save"
                }}
              </v-btn>
            </div>
          </div>
        </ValidationObserver>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { max_value, min_value, regex, required } from "vee-validate/dist/rules";
import { formatFanId, isValidFanId, normalizeFanId } from "@/utils/fan-id";
import {
  getAssignedUniversityOption,
  getDisciplines,
  getEducationalPrograms,
  getEthnicities,
  getHealthProfessions,
  getLevelOfStudies,
  getStudentStatuses,
  getUniversities,
  isUniversityScopedPreserviceUser,
} from "@/utils/helper";
import ethiopic from "ethiopic-calendar";
import preserviceBirthPlaceMixin from "@/mixins/preserviceBirthPlace";
import YearPickerField from "@/components/Graduates/shared/year-picker-field.vue";
import { YearOfEducEnum } from "@/utils/enums";
import { normalizeStudentStatusGpaItems } from "@/utils/studentStatusGpa";
import { GraduateService } from "@/components/Graduates/graduates.service";
import { applySharedPreserviceIdentity } from "@/utils/preserviceSharedIdentity";
import {
  filterGraduateEntryLevelOfStudies,
  resolveGraduateEntryBackgroundProfession,
  TVET_BACKGROUND_PROFESSION_OPTIONS,
  TVET_PRESERVICE_LEVEL,
  TVET_STUDENT_STATUS_OPTIONS,
  TVET_YEAR_OF_EDUCATION_OPTIONS,
} from "@/components/Graduates/graduate-import-utils";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("fan_id", {
  validate: (value) => isValidFanId(value),
  message: "National ID (FAN) must contain exactly 16 digits",
});
extend("post_graduate_regex", {
  ...regex,
  message: "Invalid year value. Year must have 4 digits",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letter",
});
extend("min_graduate_value", {
  ...min_value,
  message: "Minimum year value must be greater than 1950",
});
extend("max_entry_value", {
  ...max_value,
  message: "Year of Entry cannot be later than the current year",
});
extend("min_expected_value", {
  ...min_value,
  message:
    "Minimum expected year of graduation must not be less than entry year + 2",
});
extend("min_gpa", {
  ...min_value,
  message: "Invalid value. GPA must be greater than or equal to 0",
});
extend("max_gpa", {
  validate(value, { max }) {
    return Number(value) <= Number(max);
  },
  params: ["max"],
  message: "Invalid value. GPA must be less than or equal to 4",
});
export default {
  mixins: [preserviceBirthPlaceMixin],
  props: {
    graduates: Object,
    submitting: {
      type: Boolean,
      default: false,
    },
    preServiceLevel: {
      type: String,
      default: "NimeiProgram",
    },
    levelType: {
      type: String,
      default: "NIMEI Program",
    },
  },
  components: {
    YearPickerField,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    isTvetProgram() {
      return this.preServiceLevel === TVET_PRESERVICE_LEVEL;
    },
    isGraduateEntryProgram() {
      return this.preServiceLevel === "NimeiProgram";
    },
    supportsStudentGradeTracking() {
      return this.isTvetProgram || this.isGraduateEntryProgram;
    },
    isUniversityScopedUser() {
      return isUniversityScopedPreserviceUser();
    },
    programEducationTypeLabel() {
      return "Program Education Type";
    },
  },
  data() {
    return {
      formValues: {
        firstName: null,
        fatherName: null,
        grandFatherName: null,
        sex: null,
        idNo: null,
        backgroundProfession: null,
        educationProgramId: null,
        disciplineId: null,
        department: null,
        levelOfStudyId: null,
        universityId: null,
        entryYear: null,
        expectedYear: null,
        graduationYear: null,
        admissionClassification: null,
        isWithdrawn: null,
        preServiceLevel: this.preServiceLevel,
        nationality: "Ethiopia",
        ethnicity: null,
        birthRegionId: null,
        birthZoneId: null,
        birthWoredaId: null,
        birthTownVillage: null,
        editMode: false,
      },

      lookupLoading: false,
      universityLoading: false,
      currentYear: new Date().getFullYear(),
      etCurrentYear: null,
      LEVEL_OF_STUDIES: [],
      EDUCATIONAL_PROGRAMS: [],
      UNIVERSITIES: [],
      BACKGROUND_PROFESSIONS: [],
      STUDENT_STATUSES: [],
      YEAR_OF_EDUCATION: [],
      ETHNICITIES: [],
      DISCIPLINES: [],
      allDisciplines: [],
      disciplineValue: null,
      selectedUniversity: null,
      statusHeaders: [
        { text: "Year of Education", align: "start", value: "yearOfEducation" },
        { text: "Student Status", value: "studentStatus" },
        { text: "GPA", value: "gpa" },
        { text: "Cumulative GPA", value: "cumulativeGpa" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      studentStatusItems: [],
      studentStatusItem: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
        cumulativeGpa: null,
      },
      originalStudentStatus: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
        cumulativeGpa: null,
      },
      editedIndex: -1,
      editDialog: false,
      deleteDialog: false,
      skipStudentStatusDraftValidation: false,
      identityLookupLoading: false,
      lastIdentityLookupId: null,
    };
  },
  watch: {
    "formValues.educationProgramId": function (value, previousValue) {
      this.syncDisciplines(
        previousValue !== undefined && value !== previousValue,
      );
    },
    "formValues.idNo": function (value) {
      const formattedValue = formatFanId(value);
      if (formattedValue !== value) {
        this.formValues.idNo = formattedValue;
        return;
      }

      if (normalizeFanId(formattedValue) !== this.lastIdentityLookupId) {
        this.lastIdentityLookupId = null;
      }
    },
    disciplineValue: function (value) {
      if (value?.name) {
        this.formValues.department = value.name;
        this.formValues.disciplineId = value.id ?? null;
      } else {
        this.formValues.disciplineId = null;
      }
    },
  },
  async created() {
    await this.initateLookups();
    this.etCurrentYear = this.convertYearGE(this.currentYear);
    if (this.graduates != null) {
      this.formValues = {
        ...this.formValues,
        ...this.graduates,
      };
      const existingStudentStatuses = Array.isArray(
        this.graduates.pre_student_statuses,
      )
        ? this.graduates.pre_student_statuses.map(
            this.normalizeStudentStatusItem,
          )
        : Array.isArray(this.graduates.preStudentStatuses)
          ? this.graduates.preStudentStatuses.map(
              this.normalizeStudentStatusItem,
            )
          : [];
      this.studentStatusItems = this.calculateStudentStatusItems(
        existingStudentStatuses,
      );
      this.formValues.editMode = true;
      if (
        this.isGraduateEntryProgram &&
        this.formValues.backgroundProfession &&
        !this.BACKGROUND_PROFESSIONS.some(
          (item) => item?.name === this.formValues.backgroundProfession,
        )
      ) {
        this.BACKGROUND_PROFESSIONS.push({
          name: this.formValues.backgroundProfession,
        });
      }
    }
    await this.initializeUniversities();
    this.syncSelectedUniversity();
    await this.loadBirthPlaceLookups();
    this.formValues.idNo = formatFanId(this.formValues.idNo);
    this.syncDisciplines();
  },
  methods: {
    async initializeUniversities() {
      this.universityLoading = true;

      try {
        const univResp = await getUniversities();
        this.UNIVERSITIES =
          univResp.rows && univResp.rows.length > 0
            ? univResp.rows.filter((data) => data.isActive === true)
            : [];

        if (this.isUniversityScopedUser) {
          const assignedUniversity = getAssignedUniversityOption();
          if (assignedUniversity) {
            this.UNIVERSITIES = this.UNIVERSITIES.filter(
              (item) => Number(item.id) === Number(assignedUniversity.id),
            );
            if (!this.UNIVERSITIES.length) {
              this.UNIVERSITIES = [assignedUniversity];
            }
            this.selectedUniversity = this.UNIVERSITIES[0];
            this.applyUniversitySelection(this.selectedUniversity);
          }
        }
      } finally {
        this.universityLoading = false;
      }
    },
    syncSelectedUniversity() {
      if (!Array.isArray(this.UNIVERSITIES)) {
        return;
      }

      if (this.isUniversityScopedUser) {
        const assignedUniversity = getAssignedUniversityOption();
        if (assignedUniversity) {
          this.selectedUniversity =
            this.UNIVERSITIES.find(
              (item) => Number(item?.id) === Number(assignedUniversity.id),
            ) || assignedUniversity;
          this.applyUniversitySelection(this.selectedUniversity);
        }
        return;
      }

      const currentUniversityId = this.formValues.universityId;
      const currentUniversityName =
        (this.graduates?.university?.name || "").trim().toLowerCase();

      if (!currentUniversityId && !currentUniversityName) {
        this.selectedUniversity = null;
        return;
      }

      this.selectedUniversity =
        this.UNIVERSITIES.find(
          (item) =>
            Number(item?.id) === Number(currentUniversityId) ||
            (item?.name || "").trim().toLowerCase() === currentUniversityName,
        ) ||
        this.graduates?.university ||
        null;

      if (this.selectedUniversity) {
        this.applyUniversitySelection(this.selectedUniversity);
      }
    },
    applyUniversitySelection(university) {
      this.selectedUniversity = university || null;
      this.formValues.universityId = university?.id || null;
    },
    onUniversityChanged(university) {
      this.applyUniversitySelection(university);
    },
    normalizeStudentStatusItem(item = {}) {
      return {
        ...item,
        gpa: item.gpa ?? null,
        cumulativeGpa: item.cumulativeGpa ?? null,
      };
    },
    ensureBackgroundProfessionOption(name) {
      if (
        !name ||
        this.BACKGROUND_PROFESSIONS.some((item) => item?.name === name)
      ) {
        return;
      }

      this.BACKGROUND_PROFESSIONS.push({ name });
    },
    async loadExistingStudentIdentity() {
      if (this.formValues.editMode || this.identityLookupLoading) {
        return;
      }

      const normalizedId = normalizeFanId(this.formValues.idNo);
      if (!isValidFanId(normalizedId) || normalizedId === this.lastIdentityLookupId) {
        return;
      }

      this.identityLookupLoading = true;

      try {
        const response = await GraduateService.findPreServiceStudentIdentity(normalizedId);
        const identityRecord = response?.data?.data || null;
        this.lastIdentityLookupId = normalizedId;

        if (!identityRecord) {
          return;
        }

        this.formValues = applySharedPreserviceIdentity(this.formValues, identityRecord);
        this.ensureBackgroundProfessionOption(this.formValues.backgroundProfession);
        await this.syncBirthPlaceLookups();
        const enrollmentCount = identityRecord.existingEnrollments?.length || 0;
        this.$toast.info(
          enrollmentCount
            ? `Student identity loaded. ${enrollmentCount} existing enrolment(s) found; a different department is allowed.`
            : "Student information loaded from the existing national ID.",
        );
      } catch (error) {
        this.$toast.error("Unable to load student information for the selected national ID.");
      } finally {
        this.identityLookupLoading = false;
      }
    },
    calculateStudentStatusItems(items = []) {
      return normalizeStudentStatusGpaItems(
        items,
        this.YEAR_OF_EDUCATION,
      );
    },
    parseValidatedGpa(value) {
      if (value === "" || value == null) {
        return { valid: false, message: "This field is required" };
      }

      const parsedValue = Number(value);
      if (!Number.isFinite(parsedValue)) {
        return { valid: false, message: "This field is required" };
      }

      if (parsedValue < 0) {
        return {
          valid: false,
          message: "Invalid value. GPA must be greater than or equal to 0",
        };
      }

      if (parsedValue > 4) {
        return {
          valid: false,
          message: "Invalid value. GPA must be less than or equal to 4",
        };
      }

      return { valid: true, value: parsedValue };
    },
    validateStudentStatusGpas(statusItem) {
      const gpaValidation = this.parseValidatedGpa(statusItem?.gpa);
      if (!gpaValidation.valid) {
        this.$toast.error(`GPA: ${gpaValidation.message}`);
        return false;
      }
      const cumulativeGpaValidation = this.parseValidatedGpa(
        statusItem?.cumulativeGpa,
      );
      if (!cumulativeGpaValidation.valid) {
        this.$toast.error(
          `Cumulative GPA: ${cumulativeGpaValidation.message}`,
        );
        return false;
      }

      statusItem.gpa = gpaValidation.value;
      statusItem.cumulativeGpa = cumulativeGpaValidation.value;
      return true;
    },
    async initateLookups() {
      this.lookupLoading = true;
      const levelOfStudies = await getLevelOfStudies();
      const levelRows = levelOfStudies?.rows || [];
      this.LEVEL_OF_STUDIES = this.isGraduateEntryProgram
        ? filterGraduateEntryLevelOfStudies(levelRows)
        : levelRows.filter((item) => item.level_type == this.levelType);
      const lookupScope = this.isGraduateEntryProgram
        ? "postgraduate"
        : "standard";
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms({
        scope: lookupScope,
      });
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows;
      const ethnicities = await getEthnicities();
      this.ETHNICITIES = ethnicities?.rows || [];
      const disciplines = await getDisciplines({ scope: lookupScope });
      this.allDisciplines = disciplines?.rows || [];
      if (this.supportsStudentGradeTracking) {
        const studentStatuses = await getStudentStatuses();
        this.STUDENT_STATUSES = this.isTvetProgram
          ? TVET_STUDENT_STATUS_OPTIONS.map((name) => ({ name }))
          : studentStatuses?.rows || studentStatuses || [];
        this.YEAR_OF_EDUCATION = this.isTvetProgram
          ? TVET_YEAR_OF_EDUCATION_OPTIONS.map((name) => ({ name }))
          : [{ name: "Not Applicable", code: "NA" }].concat(YearOfEducEnum);
      }
      if (this.isTvetProgram) {
        this.BACKGROUND_PROFESSIONS = TVET_BACKGROUND_PROFESSION_OPTIONS.map(
          (name) => ({ name }),
        );
      } else {
        const healthProfessions = await getHealthProfessions();
        const activeProfessions = (healthProfessions?.rows || []).filter(
          (data) => data?.isActive === true,
        );
        if (this.isGraduateEntryProgram) {
          const { options, preferredProfession } =
            resolveGraduateEntryBackgroundProfession(activeProfessions);
          this.BACKGROUND_PROFESSIONS = [...options];
          if (
            this.formValues.backgroundProfession &&
            !this.BACKGROUND_PROFESSIONS.some(
              (item) => item?.name === this.formValues.backgroundProfession,
            )
          ) {
            this.BACKGROUND_PROFESSIONS.push({
              name: this.formValues.backgroundProfession,
            });
          }
          if (
            !this.formValues.backgroundProfession &&
            preferredProfession?.name
          ) {
            this.formValues.backgroundProfession = preferredProfession.name;
          }
        } else {
          this.BACKGROUND_PROFESSIONS = activeProfessions;
        }
      }
      this.lookupLoading = false;
    },
    syncDisciplines(resetSelection = false) {
      this.DISCIPLINES = this.allDisciplines.filter(
        (item) =>
          item?.educationProgramId == this.formValues.educationProgramId,
      );
      if (resetSelection) {
        this.disciplineValue = null;
        this.formValues.disciplineId = null;
        this.formValues.department = null;
        return;
      }
      this.disciplineValue =
        this.DISCIPLINES.find(
          (item) => item?.name === this.formValues.department,
        ) || null;
      this.formValues.disciplineId =
        this.disciplineValue?.id ?? this.formValues.disciplineId ?? null;
    },
    convertYearGE(val) {
      if (!val) return val;
      const year = val;
      const month = null;
      const day = null;
      let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
      return etDate.year.toString().padStart(4, "0");
    },
    async addStudentStatus() {
      if (!(await this.$refs.subForm.validate())) return;
      const draftItem = { ...this.studentStatusItem };
      if (!this.validateStudentStatusGpas(draftItem)) {
        return;
      }

      const isStatusExists = this.studentStatusItems.some(
        (item) => item.yearOfEducation === draftItem.yearOfEducation,
      );
      if (isStatusExists) {
        this.$toast.error(
          "Student grade information for this year of education already exists.",
        );
        return;
      }

      this.studentStatusItems = this.calculateStudentStatusItems([
        ...this.studentStatusItems,
        draftItem,
      ]);
      this.studentStatusItem = { ...this.originalStudentStatus };
      this.$refs.subForm.reset();
    },
    editStudentStatus(item) {
      this.editedIndex = this.studentStatusItems.indexOf(item);
      this.studentStatusItem = this.normalizeStudentStatusItem(item);
      this.editDialog = true;
    },
    cancelStudentStatusEdit() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.studentStatusItem = { ...this.originalStudentStatus };
        this.editedIndex = -1;
      });
    },
    saveStudentStatusEdit() {
      const draftItem = { ...this.studentStatusItem };
      if (!this.validateStudentStatusGpas(draftItem, this.editedIndex)) {
        return;
      }

      const duplicateStatusIndex = this.studentStatusItems.findIndex(
        (item, index) =>
          item.yearOfEducation === draftItem.yearOfEducation &&
          index !== this.editedIndex,
      );
      if (duplicateStatusIndex !== -1) {
        this.$toast.error(
          "Student grade information for this year of education already exists.",
        );
        return;
      }

      if (this.editedIndex > -1) {
        const nextItems = [...this.studentStatusItems];
        nextItems.splice(this.editedIndex, 1, draftItem);
        this.studentStatusItems = this.calculateStudentStatusItems(nextItems);
      }
      this.cancelStudentStatusEdit();
    },
    removeStudentStatus(item) {
      this.editedIndex = this.studentStatusItems.indexOf(item);
      this.deleteDialog = true;
    },
    confirmRemoveStudentStatus() {
      if (this.editedIndex > -1) {
        const nextItems = [...this.studentStatusItems];
        nextItems.splice(this.editedIndex, 1);
        this.studentStatusItems = this.calculateStudentStatusItems(nextItems);
      }
      this.closeStudentStatusDelete();
    },
    closeStudentStatusDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    async validateMainForm() {
      this.skipStudentStatusDraftValidation = true;
      await this.$nextTick();

      try {
        return await this.$refs.mainForm.validate();
      } finally {
        this.skipStudentStatusDraftValidation = false;
        await this.$nextTick();
      }
    },
    async submit() {
      if (!(await this.validateMainForm())) return;
      this.formValues.idNo = normalizeFanId(this.formValues.idNo);
      this.formValues.disciplineId =
        this.disciplineValue?.id || this.formValues.disciplineId;
      this.formValues.department =
        this.disciplineValue?.name || this.formValues.department;
      this.formValues.preServiceLevel = this.preServiceLevel;
      if (this.supportsStudentGradeTracking) {
        if (this.studentStatusItems.length === 0) {
          this.$toast.error(
            "Add at least one student grade entry before saving.",
          );
          return;
        }
        this.formValues.studentStatuses = this.studentStatusItems.map(
          (item) => ({
            yearOfEducation: item.yearOfEducation,
            studentStatus: item.studentStatus,
            gpa: item.gpa,
            cumulativeGpa: item.cumulativeGpa,
          }),
        );
        this.formValues.admissionClassification = null;
        this.formValues.isWithdrawn = null;
      } else {
        this.formValues.studentStatuses = [];
      }
      this.$emit("registerOrUpdatePreService", this.formValues);
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
